import { render, staticRenderFns } from "./ButtonsCard.vue?vue&type=template&id=e570f5c4&scoped=true"
import script from "./ButtonsCard.vue?vue&type=script&lang=js"
export * from "./ButtonsCard.vue?vue&type=script&lang=js"
import style0 from "./ButtonsCard.vue?vue&type=style&index=0&id=e570f5c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e570f5c4",
  null
  
)

export default component.exports